<template>
  <div class="position-relative">
    <div>
      <div class="overall-bg">
        <b-container>
          <b-row>
            <b-col>
              <BackBtn :goback="$router.back" />
              <Headerlayout :headertext="dataId
                ? $t(
                  'ItemCategory.LinkNewCategoryandItemtostore.EditFormHeader'
                )
                : $t(
                  'ItemCategory.LinkNewCategoryandItemtostore.FormHeader'
                )
                " :contenttext="$t(
                  'ItemCategory.LinkNewCategoryandItemtostore.FormHeaderContent'
                )
                  ">
              </Headerlayout>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <b-container class="form-white-bg">
        <b-form @submit.prevent="IsSubmit">
          <b-row>
            <b-col lg="3" md="4" sm="6">
              <div class="field">
                <!-- <CustomDropdown :label="$t('5007.storename')" id="storename" name="storename"
                    :rules="{ required: true }" :required-icon="true" :items="Storenamelist"
                    v-model="mapformdata.StoreId" @update:modelValue="() => {
                getitemcategory();
                getroombystoreid();
              }
                " :disabled="storestatus" /> -->
                <!-- {{ ModelStoreId }} -->
                <StoreDropDown :label="$t('5007.storename')" id="storename" name="storename" :rules="{ required: true }"
                  :required-icon="true" v-model="ModelStoreId" @update:modelValue="() => {
                    SelectStore(ModelStoreId);
                    getitemcategory();
                    getroombystoreid();
                  }
                    " :disabled="storestatus" />
              </div>
            </b-col>
            <b-col lg="3" md="4" sm="6">
              <div class="field">
                <CustomDropdown id="Item category" name="Item category" :label="$t('5007.category')"
                  :rules="{ required: true }" :required-icon="true" :items="Categoryoption"
                  v-model="mapformdata.ItemCategoryId" @update:modelValue="getitem()" :disabled="storestatus" />
              </div>
            </b-col>
            <b-col lg="3" md="4" sm="6">
              <div class="field">
                <CustomDropdown id="Item" name="Item" :label="$t('5007.item')" :rules="{ required: true }"
                  :required-icon="true" :items="Itemoption" v-model="mapformdata.ItemId" :disabled="storestatus" />
              </div>
            </b-col>
            <b-col lg="3" md="4" sm="6">
              <div class="field">
                <TextField :label="$t('5007.reorder')" type="text" placeholder=" " id="Reorder" name="Reorder"
                  :rules="{ required: true }" :required-icon="true" v-model="mapformdata.ReOrderLevel" />
              </div>
            </b-col>
            <b-col lg="3" md="4" sm="6">
              <div class="field">
                <CustomDropdown :label="$t('5007.room')" id="Room" name="Room" :rules="{ required: false }"
                  :required-icon="false" :items="Roomoption" v-model="mapformdata.RoomId"
                  @update:modelValue="getrackbyroomid" />
              </div>
            </b-col>
            <b-col lg="3" md="4" sm="6">
              <div class="field">
                <CustomDropdown :label="$t('5007.rack')" id="Rack" name="Rack" :rules="{ required: false }"
                  :required-icon="false" :items="Rackoption" v-model="mapformdata.RackId"
                  @update:modelValue="getrowbyrackid" />
              </div>
            </b-col>
            <b-col lg="3" md="4" sm="6">
              <div class="field">
                <CustomDropdown :label="$t('5007.row')" id="Row" name="Row" :rules="{ required: false }"
                  :required-icon="false" :items="Rowoption" v-model="mapformdata.RowId"
                  @update:modelValue="getboxbyrowid" />
              </div>
            </b-col>
            <b-col lg="3" md="4" sm="6">
              <div class="field">
                <CustomDropdown :label="$t('5007.box')" id="Box" name="Box" :rules="{ required: false }"
                  :required-icon="false" :items="Boxoption" v-model="mapformdata.BoxId" />
              </div>
              <!-- {{ Ids }}gh -->
            </b-col>
            <b-col lg="3" md="4" sm="6">
              <div class="field">
                <!-- <TextField :label="$t('5007.reorder')" type="text" placeholder=" " id="Ids" name="Ids"
                v-model="Ids" /> -->

                <!-- <InputNumber  type="number" placeholder=" " id="Ids" name="Ids"
                :rules="{ required: true }" :required-icon="true" v-model="Ids" /> -->
              </div>
            </b-col>
          </b-row>
          <b-row>
            <Footer :cancelhide="false" />
          </b-row>
        </b-form>
      </b-container>
      <b-container>
        <b-row>
          <b-col class="px-0">
            <Tableview :value="List" :paginator="true" class="p-datatable-gridlines" :rows="10" dataKey="Id"
              :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="headers"
              :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single" @row-click="RowClick">
              <template v-slot:action="{ data }">
                <span>
                  <!-- <EditIcon @click="Editdata(data)" />
                <DeleteIcon @click="Deletedata(data)" /> -->
                  <!-- <EditIcon @click="Editdata(data)" class="me-3" />
                <DeleteIcon @click="Deletedata(data)" /> -->
                  <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                    @click="toggle($event, data)" />
                </span>
              </template>
            </Tableview>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="center" v-if="loading">
      <Loader :loading="loading" />
    </div>
    <div>
      <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
      <createdsuccessfully :visible="successpop" @ok="closetrigger()" />
      <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
      <DeletedSuccessfully :visible="deletepop" @ok="deletepop = false" />
      <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete()" @no="Deletemodel = false" />
      <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit()" @no="Editmodel = false"
        :content="$t('confirmation.editcontent')" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import BackBtn from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import ItemStoreMappingService from "../../../../Service/ItemStoreMappingService";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import Storeservice from "../../../../Service/StoreService";
// import ItemCategoryservice from "../../../../Service/CategoryService";
import Itemservice from "../../../../Service/ItemMasService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import InputNumber from "../../../../../../components/FormComponents/InputNumber.vue";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import RackService from "../../../../../../modules/Inventory/Service/RackService";
import RowService from "../../../../../../modules/Inventory/Service/RowService";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import createdsuccessfully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import ItemCategoryMappingService from "../../../../../../modules/Inventory/Service/ItemCategoryMappingService";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import StoreDropDown from "../../../../../../modules/Inventory/components/DropDown/StoreDropDown.vue";
import roomService from "../../../../Service/RoomService";
import { setupHistoryManagement } from "../../../../../../modules/Inventory/Service/HistoryManage";

export default defineComponent({
  components: {
    InputNumber,
    Tableview,
    BackBtn,
    Headerlayout,
    Footer,
    CustomDropdown,
    TextField,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    createdsuccessfully,
    UpdatedSuccessfully,
    AlreadyExist,
    ItemCategoryMappingService,
    Loader,
    StoreDropDown,
  },

  setup() {
    //Session Hospital&Branch ID
    const routes = useRoute();
    let session: any = localStorage.getItem("UsersData");
    let dataId = routes.query.Id;
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    const Categoryoption = ref();
    const Itemoption = ref();
    const Rackoption = ref();
    const Roomoption = ref();
    const Rowoption = ref();
    const Boxoption = ref();
    const alreadyexistpop = ref(false);
    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    let loading1 = ref(false);
    const rowFocus = ref(false);
    const dataEdit = ref();
    let loading = ref(false);
    let storestatus = ref(false);
    let Ids = ref();
    let Idsdata = ref("");
    let mapformdata = ref({
      // IsNew: true,
      // IsModified: true,
      // IsDeleted: true,
      // IsActive: true,
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      Id: 0,
      StoreId: ref(),
      ItemCategoryId: ref(),
      ItemId: ref(),
      RoomId: ref(),
      RackId: ref(),
      RowId: ref(),
      BoxId: ref(),
      ReOrderLevel: "",
      EntityId: 0,
      StoreBranchMapId: 0,
    });

    //Get Storage from session

    // get store

    // async function getstore() {
    //   try {
    //     const dataresponse = await Storeservice.getStoreList();
    //     Storenamelist.value = dataresponse["result"].filter((items) => items.HospitalId == HospitalId && items.BranchId == BranchId).map((item: any) => {
    //       item.name = item.Name;
    //       item.value = item.Id;
    //       return item;
    //     });
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }

    // Get item category

    async function getitemcategory() {
      try {
        const dataresponse =
          await ItemStoreMappingService.StoreCategoryMappingget(
            mapformdata.value.StoreId, BranchId
          );

        Categoryoption.value = dataresponse["result"].map((item: any) => {
          item.name = item.CategoryName;
          item.value = item.CategoryId;
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    }

    // get item

    async function getitem() {
      try {
        const dataresponse = await Itemservice.getdata();

        console.log(dataresponse);
        debugger;
        Itemoption.value = dataresponse["result"]
          .filter(
            (item) => item.ItemCategoryId == mapformdata.value.ItemCategoryId
          )
          .map((item: any) => {
            item.name = item.ItemName;
            item.value = item.Id;
            return item;
          });
        console.log(Itemoption.value);
      } catch (error) {
        console.log(error);
      }
    }

    // get room name by store id

    async function getroombystoreid() {
      try {
        // const dataresponse = await ItemStoreMappingService.getroommaster(
        //   mapformdata.value.StoreId
        // );

        // Roomoption.value = dataresponse["result"].map((item: any) => {
        //   item.name = item.Name;
        //   item.value = item.Id;
        //   return item;
        // });

        const dataresponse = await roomService.getRoomByStoreId(
          mapformdata.value.StoreId,
          mapformdata.value.StoreBranchMapId
        );
        Roomoption.value = dataresponse["result"].map((item: any) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    }

    // get rack name by room id

    async function getrackbyroomid() {
      try {
        const dataresponse = await RackService.getRackByRoomId(
          mapformdata.value.RoomId
        );

        Rackoption.value = dataresponse["result"].map((item: any) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    }

    // get row name by rack name

    async function getrowbyrackid() {
      try {
        const dataresponse = await RowService.getRowByRackId(
          mapformdata.value.RackId
        );

        Rowoption.value = dataresponse["result"].map((item: any) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    }

    // get box name by rowid

    async function getboxbyrowid() {
      try {
        const dataresponse = await ItemStoreMappingService.getboxmaster(
          mapformdata.value.RowId
        );

        Boxoption.value = dataresponse["result"].map((item: any) => {
          item.name = item.BoxName;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    }

    const headers = [
      {
        header: "No",
        field: "RowNumber",
      },
      {
        header: "Store Name",
        field: "StoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Category Name",
        field: "CategoryName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Item Name",
        field: "ItemName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Room",
        field: "RoomName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Rack",
        field: "RackName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Row",
        field: "RowName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Box",
        field: "BoxName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Reorder Level",
        field: "ReOrderLevel",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        // field: "action", header: "Action", slot: "action",
        // frozencolumn: true, sortable: false
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        fieldDisplay: "false",
        class: "filterdisplaynone last-column-position",
      },
    ];

    const items = ref([]);

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      StoreName: { value: null, matchMode: FilterMatchMode.IN, options: items },
      CategoryName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ItemCount: { value: null, matchMode: FilterMatchMode.IN, options: items },
    };

    let List = ref([]);

    const globalFilterFields = ref(headers.map((col) => col.field));

    // submit form
    const { handleSubmit, errors, resetForm, resetField } = useForm();

    const IsSubmit = handleSubmit(async (values) => {
      loading.value = true;
      try {
        debugger;
        let result: any;
        // alert(Ids.value);
        mapformdata.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        mapformdata.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        mapformdata.value.BranchId = BranchId;
        mapformdata.value.HospitalId = HospitalId;
        mapformdata.value.ModifiedBy = UserId;
        mapformdata.value.CreatedBy = UserId;
        mapformdata.value.EntityId = Number(Entitydata.value.EntityId);
        mapformdata.value.RoomId = mapformdata.value.RoomId ?? 0;
        mapformdata.value.RackId = mapformdata.value.RackId ?? 0;
        mapformdata.value.RowId = mapformdata.value.RowId ?? 0;
        mapformdata.value.BoxId = mapformdata.value.BoxId ?? 0;
        if (Ids.value) {
          result = await ItemStoreMappingService.Isupdate(mapformdata.value);
        } else {
          result = await ItemStoreMappingService.Iscreate(mapformdata.value);
        }

        let msg = result["ErrorInfo"].ErrorCode;
        loading.value = false;
        if (result["result"] == "Already" && msg == null) {
          alreadyexistpop.value = true;
        } else if (msg == null) {
          successpop.value = true;
          updatepop.value = true;
        }
      } catch (error) {
        loading.value = false;
      }
    });

    //TableView
    const routers = useRouter();

    const router = useRoute();

    const storeid = router.query.Id;

    async function IsShow() {
      debugger;
      try {
        if (storeid != null) {
          const response = await ItemStoreMappingService.List(storeid, BranchId);
          storestatus.value = true;
          debugger;
          mapformdata.value.StoreId = response["result"][0]["StoreId"];
          mapformdata.value.StoreBranchMapId =
            response["result"][0]["StoreBranchMapId"];
          ModelStoreId.value = response["result"][0]["StoreId"];
          List.value = response["result"];
        } else {
          // alert('asdfasdffsadd')
        }
      } catch (error) {
        console.log(error);
      }
    }

    function RowClick(event: any) {
      debugger;
      // Editmodel.value = true;
      // rowFocus.value = true;
      // dataEdit.value = event.data;
    }

    //Loading

    let strid = 0;

    const deletepop = ref(false);

    const Deletemodel = ref(false);
    let obj = ref({});

    function Editdata(data) {
      console.log(data);
      obj.value = data;
      strid = data.StoreId;
      Editmodel.value = true;
    }

    function Deletedata(data) {
      obj.value = data;
      strid = data.StoreId;
      Deletemodel.value = true;
    }

    //Created Sucessfully Popup-Close

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      //routers.back();
      setupHistoryManagement(routers, 2);

    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      //showDialog.value = true
    }

    //IsEdit

    function IsEdit() {
      debugger;
      try {
        loading.value = true;
        let data = obj.value;
        Ids.value = obj.value["Id"];
        mapformdata.value.Id = obj.value["Id"];

        mapformdata.value.StoreId = obj.value["StoreId"];
        getitemcategory();
        mapformdata.value.ItemCategoryId = obj.value["CategoryId"];
        getitem();
        mapformdata.value.ItemId = obj.value["ItemId"];

        getroombystoreid();
        mapformdata.value.RoomId = obj.value["RoomId"];

        getrackbyroomid();
        mapformdata.value.RackId = obj.value["RackId"];

        getrowbyrackid();
        mapformdata.value.RowId = obj.value["RowId"];

        getboxbyrowid();
        mapformdata.value.BoxId = obj.value["BoxId"];

        mapformdata.value.ReOrderLevel = obj.value["ReOrderLevel"];
        loading.value = false;
        Editmodel.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    //Isdelete

    const IsDelete = async () => {
      debugger;
      loading.value = true;
      console.log(obj.value);
      let data = obj.value["StoreId"];
      let data1 = obj.value["CategoryId"];
      try {
        const response = await ItemStoreMappingService.delete(data, data1);
        let message = response["ErrorInfo"].ErrorCode;
        loading.value = false;

        if (message == null) {
          Deletemodel.value = false;
          deletepop.value = true;
        }
      } catch (error) {
        loading.value = false;
        alert(error);
      }
      IsShow();
    };

    onMounted(() => {
      mapformdata.value.StoreId = storeid;
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });

    function onKeyUp(event: any) {
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false
      ) {
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsSubmit();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit();
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      }
    }

    onMounted(() => {
      getitemcategory();
      getitem();
      getroombystoreid();
      getrackbyroomid();
      getrowbyrackid();
      getboxbyrowid();
      IsShow();
    });

    let ModelStoreId: any = ref();
    function SelectStore(value) {
      debugger;
      if (value) {
        mapformdata.value.StoreId = value.Id;
        mapformdata.value.StoreBranchMapId = value.StoreBranchMapId;
      }
    }
    const datas = ref();

    const menu = ref();
    function toggle(event, data) {
      debugger;
      datas.value = data;
      menu.value.toggle(event);
    }
    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: true,
            command: async () => {
              // amendment();
              Editdata(datas.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              // amendment();
              Deletedata(datas.value);
            },
          },
        ],
      },
    ]);
    return {
      dataId,
      Idsdata,
      // Storenamelist,
      Categoryoption,
      Itemoption,
      Roomoption,
      Rackoption,
      Rowoption,
      Boxoption,
      mapformdata,
      Ids,
      deletepop,
      alreadyclosetrigger,
      Editdata,
      Deletedata,
      IsSubmit,
      // getstore,
      getitemcategory,
      getitem,
      getroombystoreid,
      getrackbyroomid,
      getrowbyrackid,
      getboxbyrowid,
      RowClick,
      IsShow,
      IsDelete,
      IsEdit,
      closetrigger,
      headers,
      filters,
      globalFilterFields,
      loading1,
      List,
      Deletemodel,
      Editmodel,
      successpop,
      alreadyexistpop,
      toggle,
      // getitembycatid,
      storestatus,
      loading,
      SelectStore,
      ModelStoreId,
      menu,
      itemListed,
    };
  },
  created() { },
});
</script>
